import React, { useContext } from 'react';
import c from 'classnames';
import { CommentContext } from '../../CommentContext';
import ActionsMenu from '../ActionsMenu';
import BylineBlock from '../BylineBlock';
import ContentBox, { ContentBoxProps } from '../ContentBox';
import ContentTextRenderer from '../ContentTextRenderer';
import s from './ReadContentBlock.scss';

interface Props extends ContentBoxProps {
  canPostComment?: boolean;
}

/**
 * Contains the main content of a comment's read view: comment text, byline, and action menu.
 */
const ReadContentBlock: React.FC<Props> = ({
  children,
  className,
  canPostComment,
  ...rest
}) => {
  const { comment, setCanShowActionMenu } = useContext(CommentContext);

  return (
    <ContentBox
      className={c(s['root'], className)}
      onMouseEnter={() => setCanShowActionMenu(true)}
      onMouseLeave={() => setCanShowActionMenu(false)}
      {...rest}
    >
      <BylineBlock className={s['author']} />
      {!!comment.textContent && <ContentTextRenderer comment={comment} />}
      <ActionsMenu
        className={s['actions-menu']}
        canPostComment={canPostComment}
      />
    </ContentBox>
  );
};
ReadContentBlock.displayName = 'ReadContentBlock';

export default ReadContentBlock;
